import React, { useCallback, useEffect, useState } from 'react';
import { GoogleMap, InfoWindowF, useGoogleMap, useJsApiLoader } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '650px',
};

const MAP_LIBRARIES = ['marker'];

function CampusMarker({ position, tooltip, onHover, onLeave }) {
  const map = useGoogleMap();

  useEffect(() => {
    if (!map || !position || !window.google?.maps?.marker?.AdvancedMarkerElement) {
      return undefined;
    }

    const marker = new window.google.maps.marker.AdvancedMarkerElement({
      map,
      position,
      title: tooltip || '',
    });

    const handleEnter = () => {
      if (onHover) onHover();
    };
    const handleLeave = () => {
      if (onLeave) onLeave();
    };

    marker.addEventListener('mouseenter', handleEnter);
    marker.addEventListener('mouseleave', handleLeave);
    marker.addEventListener('gmp-click', handleEnter);

    return () => {
      marker.removeEventListener('mouseenter', handleEnter);
      marker.removeEventListener('mouseleave', handleLeave);
      marker.removeEventListener('gmp-click', handleEnter);
      marker.map = null;
    };
  }, [map, onHover, onLeave, position, tooltip]);

  return null;
}

function MapWithMarker({ lat, lng, tooltip }) {
  const [activeMarker, setActiveMarker] = useState(null);
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyCDc0Q7OAGczAeSVGEjKm1avct0QqZdU9s',
    libraries: MAP_LIBRARIES,
    mapIds: ['DEMO_MAP_ID'],
  });

  const latNum = parseFloat(lat);
  const lngNum = parseFloat(lng);
  const hasPosition = Number.isFinite(latNum) && Number.isFinite(lngNum);
  const center = hasPosition ? { lat: latNum, lng: lngNum } : null;

  const handleHover = useCallback(() => {
    setActiveMarker({ lat: latNum, lng: lngNum });
  }, [latNum, lngNum]);

  const handleLeave = useCallback(() => {
    setActiveMarker(null);
  }, []);

  if (!hasPosition) {
    return <div>Loading map...</div>;
  }

  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={15}
      mapId="DEMO_MAP_ID"
      options={{ mapId: 'DEMO_MAP_ID' }}
    >
      <CampusMarker
        position={center}
        tooltip={tooltip}
        onHover={handleHover}
        onLeave={handleLeave}
      />

      {activeMarker && (
        <InfoWindowF position={activeMarker} onCloseClick={() => setActiveMarker(null)}>
          <div>{tooltip}</div>
        </InfoWindowF>
      )}
    </GoogleMap>
  );
}

export default React.memo(MapWithMarker);
